import React, { useState } from "react";

import { ScrollEnable } from "../../../helpers/ScrollLock";

// Icons
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { TextUtilityButton } from "../../Buttons/Buttons";

const DeleteConfirmationField = ({
  deletionConfirmation,
  setDeletionConfirmation,
  confirmationSentence,
}) => {
  const handleInputChange = (event) => {
    const newValue = event.target.value;
    if (newValue === confirmationSentence) {
      setDeletionConfirmation(true);
    } else {
      setDeletionConfirmation(false);
    }
  };

  return (
    <div className="flex flex-col w-full items-center justify-center">
      <div className="text-base sm:text-base font-medium py-2 select-none text-neutral-800 text-center">
        {`Type "${confirmationSentence}" in CAPS to confirm.`}
      </div>
      <input
        className={
          `text-base flex w-full items-center h-10 border border-neutral-300 rounded-lg text-center
           focus:outline-none focus:ring-inset focus:ring-neutral-200 ` +
          (deletionConfirmation ? "bg-green-200" : "bg-yellow-100")
        }
        type="text"
        onChange={handleInputChange}
        placeholder={confirmationSentence}
      />
    </div>
  );
};

function DeletionModal({
  warningTitle,
  warningParagraph,
  confirmationSentence,
  cancelFunction,
  confirmFunction,
}) {
  const [deletionConfirmation, setDeletionConfirmation] = useState(false);

  return (
    <div
      className="flex flex-col items-center justify-center w-full lg:w-10/12 p-2
                 rounded-2xl Xbg-red-500"
    >
      {/* Warning icon and text */}
      <div className="flex flex-row w-full Xbg-red-500">
        <div className="sm:flex sm:items-start">
          {/* This div and its child provide the warning icon */}
          <div className="mx-auto flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-lg bg-red-100 sm:mx-0 sm:h-20 sm:w-20">
            <ExclamationTriangleIcon
              className="h-16 w-16 Xtext-red-500"
              aria-hidden="true"
            />
          </div>
          {/* The text content of the modal */}
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <p className="text-xl font-medium text-neutral-800">
              {warningTitle}
            </p>
            <div className="mt-2">
              <p className="text-base text-neutral-500">
                <b>Warning:</b> {warningParagraph}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Deletion confirmation field */}
      <div className="flex flex-row items-center justify-center w-full Xbg-yellow-500">
        <DeleteConfirmationField
          deletionConfirmation={deletionConfirmation}
          setDeletionConfirmation={setDeletionConfirmation}
          confirmationSentence={confirmationSentence}
        />
      </div>

      {/* Cancel and Delete button container */}
      <div
        className="w-full
                   sm:flex 
                   sm:flex-row-reverse 
                   sm:items-center 
                   sm:justify-between 
                   py-5
                   space-y-4 sm:space-y-0
                  "
      >
        {/* Delete button */}
        <TextUtilityButton
          prompt={"Delete"}
          color={"bg-red-400"}
          customFont={"text-xl font-medium text-white"}
          customStyles={
            "inline-flex w-full sm:w-auto items-center justify-center"
          }
          actionFunction={() => {
            confirmFunction();
            ScrollEnable();
          }}
          disabled={!deletionConfirmation}
        />

        {/* Cancel button */}
        <TextUtilityButton
          prompt={"Cancel"}
          customFont={"text-xl font-medium"}
          customStyles={
            "inline-flex w-full sm:w-auto items-center justify-center"
          }
          actionFunction={() => {
            cancelFunction();
            ScrollEnable();
          }}
        />
      </div>
    </div>
  );
}

export default DeletionModal;
